    
import React from "react";

function CheckboxMainGroupChildren(props) {
  return(
      <div>
        {
            props.children
            && props.children.length > 0 
            && <div id={ props.id + 'types' } className="ml-3 collapse" key={ props.id + 'types' }>
                    {
                        props.children.map((d,j) => {
                            return <div className="custom-control custom-checkbox" key={ props.Name }>
                                <input type="checkbox" className="custom-control-input" name="cancerspecialist"
                                    ref={el => el && (el.indeterminate = props.indeterminate)}
                                    id={d.Name} value={d.Name} checked={d.checked} onChange={props.onChange} />
                                        <label className="custom-control-label" htmlFor={ d.Name }>{ d.Text }</label>
                                    </div>;
                        })
                    }
               </div>
        }
      </div>
  );
}

export default CheckboxMainGroupChildren;